module.exports = __webpack_public_path__ + "img/TCC-L7-Pagina1 A.fccc17f7.png";